export default __webpack_public_path__ + "static/media/apple.afcbc699.png";